
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class RightSideModal extends Vue {
  closeRightSideModal(): void {
    this.$emit('close-right-side-modal');
  }
}
